import { render, staticRenderFns } from "./ReferenceDashboardGraph.vue?vue&type=template&id=65788c96&scoped=true"
import script from "./ReferenceDashboardGraph.vue?vue&type=script&lang=ts"
export * from "./ReferenceDashboardGraph.vue?vue&type=script&lang=ts"
import style0 from "./ReferenceDashboardGraph.vue?vue&type=style&index=0&id=65788c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65788c96",
  null
  
)

export default component.exports